import axios from '../axios';
import type {
  ApiEnvelope,
  Identifier,
  ListParams,
  OwnerProjectBidDto,
  PaginatedResponse,
} from './types';

const projectBidsUrl = (projectId: Identifier) =>
  `/v1/owner/manpro/projects/${projectId}/bids`;

const ownerAllBidsUrl = '/v1/owner/manpro/bids';

const ownerBidService = {
  async getBidsSummary() {
    const response = await axios.get<ApiEnvelope<any>>(
      `${ownerAllBidsUrl}/summary`,
    );
    return response.data.content;
  },

  async getAllOwnerBids(params?: ListParams) {
    const response = await axios.get<ApiEnvelope<PaginatedResponse<OwnerProjectBidDto>>>(
      ownerAllBidsUrl,
      { params },
    );
    return response.data.content;
  },

  async getOwnerProjectBids(projectId: Identifier, params?: ListParams) {
    const response = await axios.get<ApiEnvelope<PaginatedResponse<OwnerProjectBidDto>>>(
      projectBidsUrl(projectId),
      { params },
    );

    return response.data.content;
  },

  async getOwnerProjectBid(projectId: Identifier, bidId: Identifier) {
    const response = await axios.get<ApiEnvelope<OwnerProjectBidDto>>(
      `${projectBidsUrl(projectId)}/${bidId}`,
    );

    return response.data.content;
  },

  async acceptOwnerProjectBid(projectId: Identifier, bidId: Identifier) {
    const response = await axios.post<ApiEnvelope<unknown>>(
      `${projectBidsUrl(projectId)}/${bidId}/accept`,
    );

    return response.data.content;
  },

  async rejectOwnerProjectBid(projectId: Identifier, bidId: Identifier) {
    const response = await axios.post<ApiEnvelope<OwnerProjectBidDto>>(
      `${projectBidsUrl(projectId)}/${bidId}/reject`,
    );

    return response.data.content;
  },
};

export default ownerBidService;
